import { gql } from "@apollo/client"
import { apollo } from "../apollo"

const fetchSlugs = async (collectionName) => {
  try {
    const data = await apollo.query({
      query: gql`{
                entries(collection: "${collectionName}", filter: {published: {is: true}}) {
                    data {
                        uri
                        slug
                        locale
                    }
                }
            }`,
    })

    return (
      data?.data?.entries?.data
        ?.filter((path) => path.slug !== "404")
        .map((path) => {
          return {
            params: {
              slug: path.uri
                .substring(1)
                .split("/")
                .filter((x) => x),
            },
            locale: path.locale,
          }
        }) || []
    )
  } catch (e) {
    // console.log("fetchSlugs", e)
    return []
  }
}

export default fetchSlugs
